import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';


import * as notificationActions from '../notificationActions';
import * as notificationConstants from '../notificationConstants';
import * as styleUtils from '../../../../utils/styleUtils';

import {Icon, iconConstants} from '../../../global/Icon';
import useTimeout from '../../../hooks/useTimeout';

import styles from './ToastMessage.scss';


const ICON_BY_TYPE = {
    [notificationConstants.NOTIFICATION_TYPE_ERROR]: iconConstants.ICON_ERROR_CIRCLE,
    [notificationConstants.NOTIFICATION_TYPE_SUCCESS]: iconConstants.ICON_SUCCESS_CIRCLE,
    [notificationConstants.NOTIFICATION_TYPE_WARNING]: iconConstants.ICON_WARNING_CIRCLE
};


function ToastMessage({content, id, postedAt, timeout, type}) {

    const dispatch = useDispatch();

    const [isFadingOut, setIsFadingOut] = useState(false);
    const fadeOutDurationMillis = 500;
    const fadeOutStart = timeout - fadeOutDurationMillis;
    useEffect(() => {
        useTimeout(() => setIsFadingOut(true), fadeOutStart, `toast-message-${id}-fade-out`);
    }, []);

    // removal after timeout - the timeout can be extended if re-posting the same id
    useEffect(() => {

        useTimeout(
            () => dispatch(notificationActions.onRemoveToastMessage(id)),
            timeout,
            `toast-message-${id}-remove`
        );
    }, [`${id}-${postedAt}`]);

    const icon = ICON_BY_TYPE[type];

    return (
        <div className={styleUtils.toClasses(styles.toastMessage, type, isFadingOut ? styles.disappear : null)}>
            <Icon icon={icon}/>
            <span>
                {content}
            </span>
        </div>
    );
}


ToastMessage.propTypes = {
    ...notificationConstants.SHAPE_TOAST_MESSAGE
};

ToastMessage.defaultProps = {};


export default ToastMessage;
